module.exports = __webpack_public_path__ + "static/media/rules.5d74d25d.svg";